/*
 * SANBY グローバルヘッダー / フッター 挙動
 * メガメニューの開閉、モバイルドロワーの排他アコーディオン、カートバッジを制御する。
 * 全ページで読み込む共通スクリプト（spec/仕様書.md §4）。
 */
(function (SANBY) {
  const { onBreakpointChange, escapeHtml } = SANBY.utils;

  // カテゴリナビゲーションデータはlayout/theme.liquidが実コレクション/実ページURLから
  // 生成するJSON（#sanby-category-data）を読む。テーマ設定「カテゴリナビゲーション」で
  // コレクションが未設定の場合は空配列になり、該当箇所は何も表示されない。
  function readCategoryData() {
    const el = document.getElementById("sanby-category-data");
    if (!el) return { stampCategories: [], stationeryGenres: [], supportLinks: [] };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { stampCategories: [], stationeryGenres: [], supportLinks: [] };
    }
  }
  const catalog = readCategoryData();

  // カテゴリの小さいアイコン画像（正方形）は、collection.image（ヒーロー用の横長画像）とは
  // 別に、header.liquidのcategory_iconブロックで個別に保持している（サイズが違いすぎる
  // ため分離、2026-10-02）。ハンドルで突き合わせてitem.iconにマージする。
  // 未設定のカテゴリはiconがundefinedのままになり、browseItem側でimage/プレースホルダーに
  // フォールバックする。
  function readCategoryIcons() {
    const el = document.getElementById("sanby-category-icons");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }
  (function mergeCategoryIcons() {
    const icons = readCategoryIcons();
    [catalog.stampCategories, catalog.stationeryGenres].forEach((list) => {
      (list || []).forEach((item) => {
        if (icons[item.handle]) item.icon = icons[item.handle];
      });
    });
  })();

  function itemThumbHtml(item, thumbClass) {
    const src = item.icon || item.image;
    return src
      ? `<img src="${src}" alt="" class="${thumbClass}" loading="lazy">`
      : `<span class="thumb-checker ${thumbClass}"></span>`;
  }

  function megaListItem(item) {
    return `<a href="${item.href}" class="mega-item">${itemThumbHtml(item, "mega-item-thumb")}${escapeHtml(item.name)}</a>`;
  }

  function renderList(selector, items, renderItem) {
    const el = document.querySelector(selector);
    if (!el) return;
    el.innerHTML = items.map(renderItem).join("");
  }

  function initMegaMenuContent() {
    renderList("[data-mega-products-stamp]", catalog.stampCategories, megaListItem);
    renderList("[data-mega-products-genre]", catalog.stationeryGenres, megaListItem);
  }

  function asideItem(item, activeName) {
    const isActive = !!activeName && item.name === activeName;
    return `
      <a href="${item.href}" class="aside-row">
        <span class="aside-row-main">
          ${itemThumbHtml(item, "aside-row-thumb")}
          <span class="aside-row-label${isActive ? " is-active" : ""}">${escapeHtml(item.name)}</span>
        </span>
        <span class="aside-row-chevron">›</span>
      </a>`;
  }

  function asideSupportItem(item) {
    return `<a href="${item.href}" class="aside-row aside-row-plain">${escapeHtml(item.label)}<span class="aside-row-chevron">›</span></a>`;
  }

  // data-active-category を持つページ（例: CategoryLP）では、左サイドナビの該当
  // カテゴリを赤字強調する。指定がなければ何も強調しない（Top/Collectionは従来通り）。
  function initAside() {
    const activeCategory = document.body.dataset.activeCategory || "";
    renderList("[data-aside-stamp]", catalog.stampCategories, (item) => asideItem(item, activeCategory));
    renderList("[data-aside-genre]", catalog.stationeryGenres, (item) => asideItem(item, activeCategory));
    renderList("[data-aside-support]", catalog.supportLinks, asideSupportItem);
  }

  // ---------- 営業日カレンダー（左サイドナビ共通ウィジェット。Top以外のページでも再利用） ----------
  // 土日はコードで自動判定（土日祝休業のため）。それ以外の休業日（祝日・年末年始等）は
  // Shopのメタフィールド`_sc.closed_dates`（「SC管理」スプレッドシート「休業日」シート→
  // 休業日更新マクロで同期、header.liquidがJSON scriptタグとして出力）に登録された日付の
  // みを休業日として扱う（2026-10-16方針）。値は{ dates: [...], notices: [...] }の形
  // （2026-10-19、長期休業のお知らせ用にnoticesを追加）。
  function getClosedData() {
    const el = document.querySelector("[data-closed-dates]");
    const empty = { dates: new Set(), notices: [] };
    if (!el) return empty;
    try {
      const parsed = JSON.parse(el.textContent);
      if (!parsed || typeof parsed !== "object") return empty;
      return {
        dates: new Set(Array.isArray(parsed.dates) ? parsed.dates : []),
        notices: Array.isArray(parsed.notices) ? parsed.notices : [],
      };
    } catch (e) {
      return empty;
    }
  }

  // ---------- 長期休業のお知らせ（ヘッダーの帯。以前のクーポン訴求枠を転用、2026-10-16） ----------
  // 何連休かのしきい値で自動判定するのではなく、「休業日」シートC列で同じグループ名
  // （ゴールデンウィーク・お盆・年末年始等）を付けた期間だけをお知らせ対象にする方式
  // （2026-10-19、ユーザー指示：土日+1祝日程度の3連休は頻繁にあるため対象外にしたい、
  // 見せたいのは一般的に長期休業として認識されている期間だけ）。
  // 対象期間の開始日のN日前〜終了日のM日後の間だけ表示する。
  const CLOSURE_NOTICE_LOOKAHEAD_DAYS = 21;
  const CLOSURE_NOTICE_TRAILING_DAYS = 7;

  function findActiveClosureNotice(notices) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    for (const notice of notices) {
      if (!notice || !notice.start || !notice.end) continue;
      const start = new Date(`${notice.start}T00:00:00`);
      const end = new Date(`${notice.end}T00:00:00`);
      const showFrom = new Date(start);
      showFrom.setDate(showFrom.getDate() - CLOSURE_NOTICE_LOOKAHEAD_DAYS);
      const showUntil = new Date(end);
      showUntil.setDate(showUntil.getDate() + CLOSURE_NOTICE_TRAILING_DAYS);
      if (today >= showFrom && today <= showUntil) return { ...notice, start, end };
    }
    return null;
  }

  // 詳細ページ（templates/page.closure-notice.liquid）も同じ判定関数を使えるよう公開する。
  // リンクはURLパラメータを持たせない（2026-10-19、ユーザー指示：URLを書き換えれば自由に
  // 架空の内容を表示できてしまう構造だったため、詳細ページ側も`_sc.closed_dates`を直接読んで
  // 今アクティブな長期休業を自分で判定する方式に変更。ヘッダー側はリンク先URLを出すだけ）。
  SANBY.closureNotice = {
    getActive: function () {
      return findActiveClosureNotice(getClosedData().notices);
    },
  };

  function renderClosureNotice() {
    const el = document.querySelector("[data-closure-notice]");
    if (!el) return;
    const notice = SANBY.closureNotice.getActive();
    if (!notice) {
      el.hidden = true;
      el.textContent = "";
      el.removeAttribute("href");
      return;
    }
    el.textContent = `${notice.label}期間中の休業について`;
    const baseUrl = el.dataset.closureNoticeBaseUrl || "";
    if (baseUrl) el.href = baseUrl;
    el.hidden = false;
  }

  function buildCalendar(offset, closedDates) {
    const now = new Date();
    const base = new Date(now.getFullYear(), now.getMonth() + offset, 1);
    const year = base.getFullYear();
    const month = base.getMonth();
    const startWeekday = base.getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const pad = (n) => String(n).padStart(2, "0");
    const cells = [];
    for (let i = 0; i < startWeekday; i++) cells.push({ label: "", empty: true });
    for (let d = 1; d <= daysInMonth; d++) {
      const weekday = (startWeekday + d - 1) % 7;
      const isWeekend = weekday === 0 || weekday === 6;
      const dateKey = `${year}-${pad(month + 1)}-${pad(d)}`;
      const isClosed = !isWeekend && closedDates.has(dateKey);
      const isToday = offset === 0 && d === now.getDate();
      cells.push({ label: String(d), isWeekend, isClosed, isToday });
    }
    while (cells.length % 7 !== 0) cells.push({ label: "", empty: true });
    return { cells, label: `${year}年${month + 1}月` };
  }

  function renderCalendar() {
    const el = document.querySelector("[data-business-calendar]");
    if (!el) return;
    const closedDates = getClosedData().dates;
    const headers = ["日", "月", "火", "水", "木", "金", "土"];
    const calendars = [buildCalendar(0, closedDates), buildCalendar(1, closedDates)];
    el.innerHTML =
      calendars
        .map((cal) => {
          const headHtml = headers.map((h) => `<div class="calendar-cell-head">${h}</div>`).join("");
          const cellsHtml = cal.cells
            .map((c) => {
              if (c.empty) return `<div class="calendar-cell"></div>`;
              const cls = ["calendar-cell"];
              if (c.isToday) cls.push("is-today");
              else if (c.isWeekend || c.isClosed) cls.push("is-sunday");
              return `<div class="${cls.join(" ")}">${c.label}</div>`;
            })
            .join("");
          return `<div><div class="calendar-month-label">${cal.label} 営業日</div><div class="calendar-grid">${headHtml}${cellsHtml}</div></div>`;
        })
        .join("");
  }

  function browseItem(item) {
    const thumbSrc = item.icon || item.image;
    const thumb = thumbSrc
      ? `<img src="${thumbSrc}" alt="" loading="lazy">`
      : "";
    return `
      <a href="${item.href}" class="browse-row">
        <span class="browse-row-thumb">${thumb}</span>
        <span class="browse-row-label">${escapeHtml(item.name)}</span>
        <span class="browse-row-chevron">›</span>
      </a>`;
  }

  function initCategoryBrowse() {
    renderList("[data-browse-stamp]", catalog.stampCategories, browseItem);
    renderList("[data-browse-genre]", catalog.stationeryGenres, browseItem);
  }

  function footerItem(item) {
    return `<a href="${item.href}" class="footer-block-link">${escapeHtml(item.name)}</a>`;
  }

  function initFooter() {
    renderList("[data-footer-stamp]", catalog.stampCategories, footerItem);
    renderList("[data-footer-genre]", catalog.stationeryGenres, footerItem);
  }

  function drawerLinkItem(item) {
    return `<a href="${item.href}" class="drawer-link">${escapeHtml(item.name)}</a>`;
  }

  function renderDrawerGroups() {
    const container = document.querySelector("[data-drawer-groups]");
    if (!container) return;
    const groups = [
      { key: "stamp", title: "スタンプ", html: catalog.stampCategories.map(drawerLinkItem).join("") },
      { key: "genre", title: "文具雑貨", html: catalog.stationeryGenres.map(drawerLinkItem).join("") },
      { key: "support", title: "お客様サポート", html: catalog.supportLinks.map((l) => `<a href="${l.href}" class="drawer-link">${escapeHtml(l.label)}</a>`).join("") },
    ];
    container.innerHTML = groups
      .map(
        (g) => `
      <div class="drawer-group" data-drawer-key="${g.key}">
        <button type="button" class="drawer-group-title" aria-expanded="false">
          <span>${escapeHtml(g.title)}</span><span class="drawer-arrow">＋</span>
        </button>
        <div class="drawer-group-links">${g.html}</div>
      </div>`
      )
      .join("");
  }

  // ---------- メガメニュー（ホバーで開閉、単一選択） ----------
  function initMegaMenu() {
    const items = document.querySelectorAll(".nav-list > li.has-mega");
    items.forEach((li) => {
      let closeTimer = null;
      const open = () => {
        clearTimeout(closeTimer);
        items.forEach((other) => other.classList.remove("mega-open"));
        li.classList.add("mega-open");
      };
      const scheduleClose = () => {
        closeTimer = setTimeout(() => li.classList.remove("mega-open"), 120);
      };
      li.addEventListener("mouseenter", open);
      li.addEventListener("mouseleave", scheduleClose);
      li.addEventListener("focusin", open);
      li.addEventListener("focusout", (e) => {
        if (!li.contains(e.relatedTarget)) scheduleClose();
      });
    });
  }

  // ---------- モバイル検索トグル ----------
  function initMobileSearch() {
    const toggle = document.querySelector(".search-toggle-mobile");
    const form = document.querySelector(".search-form");
    if (!toggle || !form) return;
    toggle.addEventListener("click", () => {
      const isOpen = form.classList.toggle("mobile-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
      if (isOpen) form.querySelector("input")?.focus();
    });
  }

  // ---------- モバイルドロワー（排他アコーディオン、初期状態は全閉） ----------
  function initDrawer() {
    const hamburger = document.querySelector(".hamburger");
    const overlay = document.querySelector(".drawer-overlay");
    const drawer = document.querySelector(".drawer");
    const closeBtn = document.querySelector(".drawer-close");
    if (!hamburger || !drawer || !overlay) return;

    const open = () => {
      overlay.classList.add("open");
      drawer.classList.add("open");
      hamburger.setAttribute("aria-expanded", "true");
    };
    const close = () => {
      overlay.classList.remove("open");
      drawer.classList.remove("open");
      hamburger.setAttribute("aria-expanded", "false");
    };
    hamburger.addEventListener("click", open);
    overlay.addEventListener("click", close);
    closeBtn?.addEventListener("click", close);

    drawer.addEventListener("click", (e) => {
      const btn = e.target.closest(".drawer-group-title");
      if (!btn) return;
      const group = btn.closest(".drawer-group");
      const wasOpen = group.classList.contains("open");
      drawer.querySelectorAll(".drawer-group").forEach((g) => {
        g.classList.remove("open");
        g.querySelector(".drawer-group-title").setAttribute("aria-expanded", "false");
        g.querySelector(".drawer-arrow").textContent = "＋";
      });
      if (!wasOpen) {
        group.classList.add("open");
        btn.setAttribute("aria-expanded", "true");
        group.querySelector(".drawer-arrow").textContent = "－";
      }
    });

    onBreakpointChange((mobile) => {
      if (!mobile) close();
    });
  }

  // 初期値はheader.liquidがサーバー側で{{ cart.item_count }}を描画済みのため、
  // ここでは以降のカート操作（追加・数量変更・削除）で発火するsanby:cart-updated
  // イベント（detailはShopify標準のcartオブジェクト）だけを監視して同期する。
  function renderCartBadge() {
    document.addEventListener("sanby:cart-updated", (e) => {
      const count = SANBY.cartApi.itemCount(e.detail);
      document.querySelectorAll("[data-cart-badge]").forEach((badge) => {
        badge.textContent = String(count);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMegaMenuContent();
    initMegaMenu();
    initMobileSearch();
    initAside();
    renderCalendar();
    renderClosureNotice();
    initCategoryBrowse();
    initFooter();
    renderDrawerGroups();
    initDrawer();
    renderCartBadge();
  });
})(window.SANBY);
